"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["children", "fallback", "errorFallback", "onError"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { c as _c } from "react/compiler-runtime";
import { ENV_NAME } from '@autoguru/global-configs';
import { logException, useLoggingAgent } from '@autoguru/logs';
import { Suspense, useCallback } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { AsyncFallback } from '../AsyncFallback';
import { ErrorFallback } from '../ErrorFallback';
import { jsx as _jsx } from "react/jsx-runtime";
const logError = (error, info, agent) => logException(error, {
  react: {
    componentStack: info === null || info === void 0 ? void 0 : info.componentStack
  }
}, agent);
const FallbackSpinner = /*#__PURE__*/_jsx(AsyncFallback, {});
export const AsyncBoundary = t0 => {
  const $ = _c(19);
  let ErrorFallbackElement;
  let children;
  let incomingOnError;
  let suspenseProps;
  let t1;
  if ($[0] !== t0) {
    var _t = t0;
    ({
      children,
      fallback: t1,
      errorFallback: ErrorFallbackElement,
      onError: incomingOnError
    } = _t);
    suspenseProps = _objectWithoutProperties(_t, _excluded);
    _t;
    $[0] = t0;
    $[1] = ErrorFallbackElement;
    $[2] = children;
    $[3] = incomingOnError;
    $[4] = suspenseProps;
    $[5] = t1;
  } else {
    ErrorFallbackElement = $[1];
    children = $[2];
    incomingOnError = $[3];
    suspenseProps = $[4];
    t1 = $[5];
  }
  const fallback = t1 === undefined ? FallbackSpinner : t1;
  const agent = useLoggingAgent();
  let t2;
  if ($[6] !== agent || $[7] !== incomingOnError) {
    t2 = (error, info) => {
      logError(error, info, agent);
      if (typeof incomingOnError === "function") {
        incomingOnError(error, info);
      }
    };
    $[6] = agent;
    $[7] = incomingOnError;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const actionOnError = t2;
  const fallbackRender = _temp;
  let t3;
  if ($[9] !== ErrorFallbackElement) {
    t3 = ErrorFallbackElement ? () => ErrorFallbackElement : fallbackRender;
    $[9] = ErrorFallbackElement;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== children || $[12] !== fallback || $[13] !== suspenseProps) {
    t4 = /*#__PURE__*/_jsx(Suspense, _objectSpread(_objectSpread({}, suspenseProps), {}, {
      fallback: fallback,
      children: children
    }));
    $[11] = children;
    $[12] = fallback;
    $[13] = suspenseProps;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== actionOnError || $[16] !== t3 || $[17] !== t4) {
    t5 = /*#__PURE__*/_jsx(ErrorBoundary, {
      onError: actionOnError,
      fallbackRender: t3,
      children: t4
    });
    $[15] = actionOnError;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
function _temp(t0) {
  const {
    error: error_0,
    resetErrorBoundary
  } = t0;
  return /*#__PURE__*/_jsx(ErrorFallback, {
    error: error_0,
    hideDetails: ENV_NAME === "prod",
    resetErrorBoundary: resetErrorBoundary
  });
}